import Vue from 'vue';
import ApiInterface from './apiController';

export default class AxiosApiController extends ApiInterface {
  Get(path, params, headers = {}) {
    return Vue.axios({
      method: 'GET',
      url: path,
      params: params,
    });
  }

  Post(path, params, headers = {}) {
    return Vue.axios({
      method: 'POST',
      url: path,
      data: params,
      headers: headers,
    });
  }

  Delete(path, params = {}, headers = {}) {
    return Vue.axios({
      method: 'DELETE',
      url: path,
      data: params,
    });
  }

  Patch(path, params, headers = {}) {
    return Vue.axios({
      method: 'PATCH',
      url: path,
      data: params,
      headers: headers,
    });
  }

  Put(path, params, headers = {}) {
    return Vue.axios({
      method: 'PUT',
      url: path,
      data: params,
      headers: headers,
    });
  }
}
